import AndyBot from "../assets/icons/assignments/andybot.svg";
import Cartoon from "../assets/icons/assignments/cartoon.svg";
import DoodleJump from "../assets/icons/assignments/doodle-jump.svg";
import FruitNinja from "../assets/icons/assignments/fruit-ninja.svg";
import Indy from "../assets/icons/assignments/indy.svg";
import Othello from "../assets/icons/assignments/othello.svg";
import PacMan from "../assets/icons/assignments/pacman.svg";
import Pong from "../assets/icons/assignments/pong.svg";
import Rattytouille from "../assets/icons/assignments/rattytouille.svg";
import Sketchy from "../assets/icons/assignments/sketchy.svg";
import Tetris from "../assets/icons/assignments/tetris.svg";
import TicTacToe from "../assets/icons/assignments/tic-tac-toe.svg";

/** Decorative hover icons keyed by assignment name. */
export const assignmentIcons: Record<string, string> = {
  Rattytouille,
  AndyBot,
  Pong,
  TicTacToe,
  "Fruit Ninja": FruitNinja,
  Cartoon,
  DoodleJump,
  Tetris,
  PacMan,
  Sketchy,
  Othello,
  Indy,
};
